// pages/AllMasters.jsx
import React from 'react';
import MasterListBase from './MasterListBase';

const AllMasters = () => (
    <MasterListBase statusFilter="all" title="All Masters" subtitle="Every registered masters, active and inactive" />
);

export default AllMasters;